import MerchantSearch from './MerchantSearch.js';

/**
 * @param {HTMLElement|null} merchantSearch
 */
export function initMerchantSearch(merchantSearch = null) {
    /** @type {HTMLElement|NodeListOf<HTMLElement>} */
    const merchantSearchPlugins = merchantSearch ?? document.querySelectorAll('.tx-avmplugins-merchantsearch');
    if (!merchantSearchPlugins) {
        return;
    }

    if (merchantSearchPlugins instanceof HTMLElement) {
        appendPluginMerchantSearch(merchantSearchPlugins);
    } else {
        merchantSearchPlugins.forEach((element) => {
            appendPluginMerchantSearch(element);
        });
    }
}

const appendPluginMerchantSearch = (element) => {
    const hasPrivacyOverlay = element.querySelector('.privacy-overlay');
    if (hasPrivacyOverlay) {
        element.addEventListener('privacyoverlay:close', () => {
            new MerchantSearch(element);
        });
    } else {
        new MerchantSearch(element);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    initMerchantSearch();
});
